module.exports = __webpack_public_path__ + "media/images/icon-arrow-next-ac94a7336b29249eac41e1ade8e1d251.svg";